import React, { useEffect } from "react"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { getZoneDetails } from "store/actions/zoneAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import Switch2 from "components/Shared/Switch2"
import RegionBoundaryView from "../Regions/RegionBoundaryView"

const ZoneDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Zone Details `)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, zoneDetails } = useSelector(state => state.Zone)

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      43,
      "zone_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  useEffect(() => {
    const fetchOldDetails = () => {
      const payload = {
        id,
      }
      dispatch(getZoneDetails(payload))
    }
    fetchOldDetails()
  }, [])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {t("Zone Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={650} rounded />
                  ) : Object.values(zoneDetails).length === 0 ? (
                    <p className="text-center my-2">
                      {t("No zone details found")}
                    </p>
                  ) : (
                    <Table className="table-nowrap mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{zoneDetails._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name(English)")}</th>
                          <td>{zoneDetails?.name}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name(عربي)")}</th>
                          <td>{zoneDetails?.nameAr}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("City")}</th>
                          <td>
                            {language === "sa"
                              ? zoneDetails?.city?.nameAr
                              : zoneDetails?.city?.name}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Minimum Delivery Days")}</th>
                          <td>{zoneDetails?.minDays || 0}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Maximum Delivery Days")}</th>
                          <td>{zoneDetails?.maxDays || 0}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Min Order Amount")}</th>
                          <td>{zoneDetails?.minOrderAmount ?? 0}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Delivery Charges")}</th>
                          <td>{zoneDetails?.deliveryCharges ?? 0}</td>
                        </tr>
                        <tr>
                          <th scope="row">
                            {t("Free Delivery Up To Order Amount")}
                          </th>
                          <td>{zoneDetails?.freeDeliveryOrderAmount ?? 0}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Enable Delivery")}</th>
                          <td>
                            <Switch2
                              id="deliveryEnabled"
                              isChecked={zoneDetails?.deliveryEnabled}
                              isReadOnly={true}
                            />
                          </td>
                        </tr>
                        {zoneDetails?.deliveryEnabled && (
                          <tr>
                            <th scope="row">{t("Delivery Boundary")}</th>
                            <td>
                              <RegionBoundaryView
                                boundary={zoneDetails?.boundary}
                                zoneLabel={
                                  language === "sa"
                                    ? zoneDetails?.nameAr || zoneDetails?.name
                                    : zoneDetails?.name || zoneDetails?.nameAr
                                }
                              />
                            </td>
                          </tr>
                        )}
                        <tr>
                          <th scope="row">{t("Status")}</th>
                          <td>
                            {zoneDetails?.status === 1 ? (
                              <Badge className="bg-success">
                                {t("Active")}
                              </Badge>
                            ) : (
                              <Badge className="bg-danger">
                                {t("Deactive")}
                              </Badge>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default ZoneDetails
